<template>
  <td>
    <router-link :to="'/dialogkontrolle/' + dialogId">
      {{ dialogId }}
    </router-link>
  </td>
</template>

<script lang="babel">
export default {
    props: ['model'],
    computed: {
      dialogId() {
        if (this.model.customer_profile_id > this.model.fake_profile_id) {
          return this.model.fake_profile_id + "-" + this.model.customer_profile_id;
        } else if(this.model.dialogMessageId) {
          return this.model.dialogMessageId;
        } else if(this.model.received_messages && this.model.received_messages[0].dialogMessageId) {
          return this.model.received_messages[0].dialogMessageId;
        } else {
          return this.model.customer_profile_id + "-" + this.model.fake_profile_id;
        }
      }
    }
};
</script>
